module.exports = __webpack_public_path__ + "img/kakao-certification.6efd17ff.png";